import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/salesSlotBooking.module.css";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import {
  getGenerateUrl,
  langoptions_preview,
  removeCommonLocation,
  roles,
} from "../../utils/constants";

import EditIconsSvg from "../../assets/images/edit-icon.svg";
import logsIconSvg from "../../assets/images/hamburger.svg";
import DeleteIconSvg from "../../assets/images/delete_icon.svg";
import viewIconSvg from "../../assets/images/view_icon.svg";
import BookSlot from "./BookSlot";
import SlotVIew from "./SlotVIew";
import API from "../../services/api";
import SlotHistory from "./SlotHistory";
import { useNavigate } from "react-router";

function SlotModelView(props) {
  let { dateFilter, setDateFilter } = props;
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  //Finance consts
  const [editItem, setEditItem] = useState(null);
  const [bookSlotModalOpen, setBookSlotModalOpen] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [slotView_id, setSlotView_id] = useState(null);
  const [slotLog_id, setSlotLog_id] = useState(null);

  const getSlotsData = async () => {
    try {
      setLoader(true);
      const result = await API({
        url: "/slotbooking/get-booking-data",
        method: "POST",
        data: props.filterData,
        responseType: "json",
      });
      if (result.code === 200) {
        setData(result.data[0]);
        setInitialRender(false);
      }
      setLoader(false);
      if (result.status === 401) navigate("/");
    } catch (error) {
      console.error("Error @ getSlotsData", error);
    }
  };

  useEffect(() => {
    getSlotsData();
  }, []);
  useEffect(() => {
    if (!bookSlotModalOpen && !initialRender && !slotView_id && !slotLog_id) {
      getSlotsData();
    }
  }, [bookSlotModalOpen, slotView_id, slotLog_id]);

  const handleViewAction = async (slotItem) => {
    setSlotView_id(slotItem.slot_id);
  };
  const handleLogAction = async (slotItem) => {
    setSlotLog_id(slotItem.slot_id);
  };

  const handleEditAction = async (slotItem) => {
    try {
      let apiResult = await API({
        url: "/slotbooking/slot_details",
        method: "POST",
        responseType: "json",
        data: { slot_id: slotItem.slot_id },
      });
      if (apiResult.code === 200) {
        setEditItem({
          ...apiResult.data,
          action: "edit",
        });
        setBookSlotModalOpen(true);
        setInitialRender(false);
      }
    } catch (error) {
      console.error("Error @ handleEditAction", error);
    }
  };

  return (
    <div id="modal1" class={styles["slotViewModal"]}>
      <div class={styles["modalContent"]}>
        <div class={styles["header"]}>
          <h1>{dateFilter.startDate}</h1>
          <ul>
            <li>Approved</li>
            <li>Rejected</li>
            <li>Pending</li>
            <li>Finance Pending</li>
          </ul>
          <span
            class={styles["close"]}
            onClick={() => {
              setDateFilter(null);
            }}
          >
            &times;
          </span>
        </div>
        <div class={styles["modalBody"]}>
          <div class={styles["dayPosCard"]}>
            <div class={styles["card-wrapper"]}>
              {data?.positionsData?.length && !loader ? (
                data.positionsData.map((positionItem) => {
                  return (
                    <div
                      className={`${styles["slot-card"]} ${
                        positionItem?.slots?.length > 1
                          ? `${styles["multi-pos"]}`
                          : ""
                      } ${
                        positionItem?.slots?.filter((mitem) => mitem?.mine)
                          .length
                          ? styles["my-slot"]
                          : ""
                      }`}
                    >
                      <div className={styles["slot-position"]}>
                        <span>{`${
                          positionItem.position === -1
                            ? "SOV"
                            : `P${positionItem.position}`
                        }`}</span>
                      </div>
                      {positionItem.slots.map((slotItem) => {
                        let {
                          slot,
                          actualTarget,
                          state_Objs,
                          district_Objs,
                          mandal_Objs,
                          constituency_Objs,
                          village_Objs,
                          sales_name,
                          slot_name,
                        } = slotItem;
                        return (
                          <div
                            className={`${styles["slot-details"]} ${
                              slotItem.status === 1
                                ? styles["pending"]
                                : slotItem.status === 2
                                ? styles["finance_pending"]
                                : slotItem.status === 3
                                ? styles["approved"]
                                : slotItem.status === 4
                                ? styles["rejected"]
                                : styles["deleted"]
                            }  ${
                              slotItem.mine ||
                              localStorage.getItem("role") === roles.financer
                                ? styles["my-slot"]
                                : ""
                            }`}
                          >
                            <div className={styles["slot-row"]}>
                              {slotItem?.logo_url ||
                              getGenerateUrl(slotItem?.brand_name || "") ? (
                                <img
                                  src={
                                    slotItem?.logo_url ||
                                    getGenerateUrl(slotItem?.brand_name || "")
                                  }
                                  className={styles["brand-logo"]}
                                  title={slotItem.brand_name}
                                />
                              ) : null}
                              {/* <h3>
                                      {capitalizeFirstLetter(
                                        slotItem.brand_name
                                      )}
                                    </h3> */}
                              <h2 className={styles["slot-placement"]}>
                                <span>
                                  {slot === 0
                                    ? "A"
                                    : slot === 1
                                    ? "B"
                                    : slot === 2
                                    ? "C"
                                    : "-"}
                                </span>
                              </h2>
                              <p>{slot_name}</p>
                              <h9
                                className={`ml-auto ${styles["maxwidth"]}`}
                                title={slotItem.brand_name}
                              >
                                {slotItem.brand_name}
                              </h9>
                              <h6
                                className={`ml-1 ${styles["maxwidth"]}`}
                                title={sales_name}
                              >
                                {sales_name}
                              </h6>
                              {/* <img
                                      src="images/exec-1.png"
                                      alt=""
                                      className="executive-logo"
                                    /> */}
                              {/* <div className={styles["duration"]}>
                                      <label>{slotItem.sales_name}</label>
                                      <img src={durationClockSvg} alt="" />
                                      <p>
                                        Duration :{" "}
                                        <span>
                                          {differenceInDays(
                                            new Date(slotItem.end_date * 1000),
                                            new Date(slotItem.start_date * 1000)
                                          ) || 1}{" "}
                                          Day
                                        </span>
                                      </p>
                                      
                                    </div> */}
                            </div>

                            <div className={styles["slot-row"]}>
                              <ul className={styles["locations-list"]}>
                                {actualTarget?.lang_ids && actualTarget?.lang_ids?.length > 0 ? actualTarget?.lang_ids?.map((lang_id) => (
                                  <li
                                    className={styles["lang"]}
                                  >{`${langoptions_preview[lang_id]}`}</li>
                                )) : null}

                                {actualTarget?.state_ids?.length ? state_Objs
                                  .filter((st) =>
                                    actualTarget.state_ids.includes(st.state_id)
                                  )
                                  .map((item) => (
                                    <li
                                      className={styles["state"]}
                                    >{`${item.state_name}`}</li>
                                  )) : null}

                                {actualTarget?.district_ids?.length ? district_Objs
                                  .filter((di) =>
                                    actualTarget.district_ids.includes(
                                      di.dist_id
                                    )
                                  )
                                  .map((item) => (
                                    <li
                                      className={styles["dist"]}
                                    >{`${item.dist_name}`}</li>
                                  )) : null}

                                {constituency_Objs?.length ? constituency_Objs?.map((item) => (
                                  <li
                                    className={styles["consti"]}
                                  >{`${item.const_name}`}</li>
                                )) : null}
                                {/* </ul>
                                        </li>
                                      ) : null} */}
                                {/* {mandal_Objs
                                        .filter((ma) =>
                                          actualTarget.mandal_ids.includes(
                                            ma.mandal_id
                                          )
                                        )
                                        .map((item) => (
                                          <li>{`M: ${item.mandal_name}`}</li>
                                        ))}
                                      {village_Objs
                                        .filter((vi) =>
                                          actualTarget.village_ids.includes(
                                            vi.village_id
                                          )
                                        )
                                        .map((item) => (
                                          <li>{`V: ${item.village}`}</li>
                                        ))} */}
                              </ul>
                            </div>
                            {/* Card Hover Options */}

                            <div className={styles["options"]}>
                              {localStorage.getItem("role") ===
                                roles.salesperson &&
                              slotItem.mine &&
                              slotItem.status === 4 ? (
                                <button
                                  id="edit"
                                  className={styles["editSlot"]}
                                  onClick={() => {
                                    handleEditAction(slotItem);
                                  }}
                                >
                                  <img src={EditIconsSvg} alt="" />
                                  <span>Edit</span>
                                </button>
                              ) : null}
                              <button
                                id="view"
                                onClick={() => {
                                  handleViewAction(slotItem);
                                }}
                              >
                                <img src={viewIconSvg} alt="" />
                                <span>View</span>
                              </button>
                              <button
                                id="logs"
                                onClick={() => {
                                  handleLogAction(slotItem);
                                }}
                              >
                                <img src={logsIconSvg} alt="" />
                                <span>Logs</span>
                              </button>
                              {/* <button
                                id="delete"
                                onClick={() => {
                                  setDeleteSlotData(slotItem);
                                }}
                              >
                                <img src={DeleteIconSvg} alt="" />
                                <span>Delete</span>
                              </button> */}
                            </div>
                            {slotItem.order_id ? (
                              <div
                                className={`${styles["picked"]} ${styles["large"]}`}
                              >
                                {" "}
                              </div>
                            ) : null}
                          </div>
                        );
                      })}
                    </div>
                  );
                })
              ) : !data?.length && !loader ? (
                <div className="w-full h-full d-flex justify-center">
                  <NoDataFound colspan="15" />
                </div>
              ) : (
                <div className="w-full h-full d-flex justify-center">
                  <TableLoader colspan="15" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {bookSlotModalOpen && (
        <BookSlot
          show={bookSlotModalOpen}
          setShow={setBookSlotModalOpen}
          editItem={editItem}
        />
      )}
      {slotView_id ? (
        <SlotVIew slot_id={slotView_id} setSlot_id={setSlotView_id} />
      ) : null}
      {slotLog_id ? (
        <SlotHistory slotLog_id={slotLog_id} setSlotLog_id={setSlotLog_id} />
      ) : null}
    </div>
  );
}

export default SlotModelView;
